import store from '@/store'
import { GameService } from '@/services'
import { normalizeJackpotValue, parseRuntimeJackpot } from '@/utils/jackpot'
import { resolveSiteCurrency } from '@/utils/siteBrand'

export const RUNTIME_JACKPOT_POLL_MS = 5000

export function applyRuntimeJackpotToStore (jackpot, siteInfo = store.state.siteInfo) {
  const currency = resolveSiteCurrency(siteInfo)
  const normalized = normalizeJackpotValue(jackpot, currency)
  if (normalized == null) return false
  const current = parseRuntimeJackpot(store.state.runtimeJackpot)
  if (current != null && current === normalized) return false
  store.commit('SET_RUNTIME_JACKPOT', normalized)
  return true
}

export async function fetchRuntimeJackpot (siteInfo, options = {}) {
  try {
    const res = await GameService.getJackpotApi({
      skipSessionGuard: options.skipSessionGuard !== false
    })
    const body = res && res.data ? res.data : null
    if (body && body.code === 0 && body.data) {
      applyRuntimeJackpotToStore(body.data.jackpot, siteInfo)
    }
  } catch (err) {
    // public jackpot display is best-effort
  }
}
